import React, { FunctionComponent, useContext } from 'react'

import { ASSETS_CDN_URL } from '../../constants'
import { ProductTypeContext } from '../../utils/productType/productTypeContext'
import { tID } from '../../utils/utils'
import { Image } from '../image/Image'

export interface SparklesAvatarIconProps {
  size?: number | string
}

// This will work with Avatars of height=77 and width=77, see SparklesAvatarIcon.stories.tsx for how to use
export const SparklesAvatarIconImage: FunctionComponent<SparklesAvatarIconProps> = ({ size = 125, ...props }) => {
  const { isLyraSelect } = useContext(ProductTypeContext)
  const fileName = isLyraSelect ? 'lyraSelectSparklesAvatarIcon2.png' : 'sparklesAvatarIcon.png'
  const uri = `${ASSETS_CDN_URL}${fileName}`

  return (
    <Image
      source={{ uri }}
      style={{
        width: size,
        height: typeof size === 'string' ? size : Math.round((size as number) * (78 / 125)), // Maintain aspect ratio
        backgroundColor: 'transparent',
      }}
      contentFit='contain'
      testID={tID('SparklesAvatarIconImage')}
      alt='Sparkles avatar icon'
      {...props}
    />
  )
}

export default SparklesAvatarIconImage
